import { Seo } from "../components/site/Seo";
import { PageHero } from "../components/site/PageHero";
import { InfoGrid, QuoteSection } from "../components/site/Sections";
import { Steps } from "../components/site/Steps";
import { FaqSection } from "../components/site/FaqSection";
import { Reveal, Eyebrow } from "../components/site/Reveal";
import { FAQS } from "../lib/content";
import { scrollToId } from "../lib/site";

const ITEMS = [
  { title: "Como funciona a energia solar fotovoltaica", text: "Os painéis convertem a luz solar em eletricidade. O inversor adapta-a à instalação da casa e a energia é consumida no momento em que é produzida. Quando não há produção suficiente, a rede continua a fornecer eletricidade." },
  { title: "Fatores que influenciam o dimensionamento", text: "Consumo anual, potência contratada, área útil do telhado, orientação, inclinação e sombreamentos determinam a potência adequada do sistema." },
  { title: "Hábitos de consumo", text: "A energia solar é produzida durante o dia. Perceber quando consome — e o que pode ser deslocado para as horas de sol — ajuda a aproveitar melhor a produção." },
  { title: "Características do telhado", text: "O tipo de cobertura (telha cerâmica, terraço, chapa), o seu estado e a estrutura de fixação influenciam a solução e a forma de instalação." },
  { title: "Opções de armazenamento", text: "As baterias permitem guardar energia produzida e não consumida para utilizar mais tarde. A disponibilidade e a adequação são analisadas sob consulta." },
  { title: "Como solicitar uma avaliação", text: "Preencha o formulário abaixo com os dados essenciais. Se tiver uma fatura recente, o valor aproximado ajuda a acelerar a análise." },
];

export default function ResidencialPage() {
  return (
    <>
      <Seo title="Painéis Solares para Habitações | Mega Solar" path="/solucoes-residenciais"
        description="Painéis solares para moradias e habitações em Portugal. Sistemas fotovoltaicos dimensionados ao seu consumo e ao seu telhado. Peça um orçamento residencial gratuito." />
      <PageHero testId="residential-hero" eyebrow="Soluções residenciais" lines={["Energia solar", "para a sua casa."]}
        text="Sistemas fotovoltaicos para habitações, pensados a partir do seu consumo, dos seus hábitos e das características do seu telhado."
        image="/images/telhado.jpg" alt="Painéis solares instalados num telhado de telha cerâmica de uma habitação">
        <button type="button" onClick={() => scrollToId("formulario")} className="btn-gold mt-10" data-testid="residential-hero-quote-button">Pedir Orçamento Residencial</button>
      </PageHero>
      <InfoGrid testId="residential-info" eyebrow="O que deve saber" title="Uma instalação à medida da sua habitação." items={ITEMS} />
      <section className="bg-forest-deep py-24 text-white sm:py-32">
        <div className="container-x">
          <Eyebrow light>Processo</Eyebrow>
          <Reveal><h2 className="mt-5 font-display text-4xl font-semibold tracking-tight sm:text-5xl">Do pedido à instalação.</h2></Reveal>
          <div className="mt-16"><Steps light /></div>
        </div>
      </section>
      <QuoteSection tipo="residencial" origem="residencial" lockTipo title="Peça o seu orçamento residencial."
        text="Sem custos nem compromisso. Analisamos o seu pedido e entramos em contacto para esclarecer os detalhes." />
      <FaqSection items={FAQS.filter((_, i) => [1, 2, 4, 6].includes(i))} withSchema={false} />
    </>
  );
}
